import { Injectable } from "@angular/core";
import { OpenEnrollmentCompleteData } from "../interfaces/openEnrollmentCompleteData";

@Injectable()
export class OpenEnrollmentChartService
{
    ChartData: OpenEnrollmentCompleteData[];

    planCode: string;

    GetData(): OpenEnrollmentCompleteData[]
    {
        return this.ChartData;
    }

    GetPlanCode(): string
    {
        return this.planCode;
    }

    SetData(data: OpenEnrollmentCompleteData[]): void
    {
        this.ChartData = data;
    }

    SetPlanCode(code: string): void
    {
        this.planCode = code;
    }
}
